import React from "react"
import { Col, Row, Form } from "react-bootstrap"
import { Field, getIn } from "formik"
import FormLabel from "./formLabel"

function FormFieldDisableAutoComplete(props) {
  const { textDesc, form, field, toUpperCase } = props

  const errorsMsg = getIn(form.errors, field.name)

  const inputErrorClassName = (touched, errors, inputName) => {
    //  (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? "is-invalid" : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    //  (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  return (
    <div
      style={{ overflow: "hidden", height: "0px", background: "transparent" }}
      data-description={"dummyPanel for Chrome auto-fill issue"}
    >
      <Form.Group>
        <Row>
          <FormLabel text={textDesc} />
          <Col xs={12} md={6} className="marginTop10px">
            <Field
              name={field.name + "fakeusernameremembered"}
              className={
                "inputbox " +
                inputErrorClassName(form.touched, form.errors, field.name)
              }
              type="text"
              autoComplete="username"
              value={
                toUpperCase
                  ? field.value.toUpperCase()
                  : field.value
                  ? field.value
                  : ""
              }
              readOnly
            />
            <Field
              name={field.name + "fakepasswordremembered"}
              className={
                "inputbox " +
                inputErrorClassName(form.touched, form.errors, field.name)
              }
              type="password"
              autoComplete="password"
              value={
                toUpperCase
                  ? field.value.toUpperCase()
                  : field.value
                  ? field.value
                  : ""
              }
              readOnly
            />
            {inputErrorMessage(form.touched, form.errors, field.name)}
          </Col>
        </Row>
      </Form.Group>
    </div>
  )
}

export default FormFieldDisableAutoComplete
